import React, { useState, useEffect } from "react";
import './Timeline.css';

export const schoolTimeline = [
  { 
    year: "1996-1997", 
    text: "Set up infrastructure, Developed Academic programme, Developed Administrative procedures, Opened Admissions for grade 1 to 7, Authorisation visit by IB inspector, Authorisation letter for MYP from IBO, Teachers sent to Bangkok for training, Dawn supplement, School Carnival, Developed Academic programme for grade 8"
  },
  { 
    year: "1997-1998", 
    text: "Opened grade 8 for admission, Developed Design and Technology Workshop, Principal attended Heads of School Conference, Halloween Carnival, Introduced annual cricket match between staff and students to be played on 14th August (Independence Cup), Developed Academic programme for grade 9"
  },
  { 
    year: "1998-1999", 
    text: "Opened grade 9 for admission, Introduced security deposit, Students’ trip to North Pakistan & Afghanistan, Swimming Gala, Olympics introduced as annual events, Organised first Drama Festival, Developed curriculum for grade 10"
  },
  { 
    year: "1999-2000", 
    text: "Opened grade 10 for admission, Graduated first MYP batch of 21 students, Students’ trip to Mohenjo-Daro, Dawn supplement, Added second building, Developed Academic programme for High School (DP)"
  },
  { 
    year: "2000-2001", 
    text: "Opened grade 11 for admission, Set up infrastructure and procedures for High School, Teachers sent to Bahrain and Hong Kong for Diploma Training, Students attended Model United Nations (MUN) Programme in Sri Lanka, Authorisation letter for Diploma Programme from IBO"
  },
  { 
    year: "2001-2002", 
    text: "Set up infrastructure and procedures for pre-school, Authorisation letter for Diploma Programme from IBO, Set up College advisory service, Graduated first IB Diploma batch of 30 students to College and Universities across the world including Pakistan"
  },
  { 
    year: "2002-2003", 
    text: "Graduated MYP and Diploma batches to College and Universities across the world including Pakistan"
  },
  { 
    year: "2003-2004", 
    text: "Registered with Cambridge International Examinations, UK, Registered with Edexcel International, UK"
  },
  { 
    year: "2004-2005", 
    text: "Graduated MYP and Diploma batches to College and Universities across the world including Pakistan, Introduced Rowing and Sailing as sporting events, Participated in the first Inter-School Rowing Regatta"
  },
  { 
    year: "2008-2009", 
    text: "Organised and hosted the first TIS Model United Nations Conference"
  },
  { 
    year: "2009-2010", 
    text: "Many teachers register for the 6-week IB authorised online workshops"
  },
  { 
    year: "2010-2011", 
    text: "Signed a Memorandum of Understanding (MOU) with Institute of Education (IOE), University of London for the development of teachers and educational, Registered Trust for Advancement for Knowledge and Understanding (TAKE), Conducted the first Short Course in Teaching and School Leadership in association with IOE, Completed the mandatory 5 years review of IB Diploma Programme"
  },
  { 
    year: "2011-2012", 
    text: "Chairperson of Board and Head of school attended the IB Heads Conference in Singapore to raise the issue of IB in Pakistan with IBO leadership, Attended the first South Asian IB Schools’ Association (SAIBSA) conference in Kathmandu, Nepal"
  },
  { 
    year: "2012-2013", 
    text: "Secures IB Primary Years Programme (PYP) candidate status to become a full IB World School with all three programmes, Completes the first IB PYP consultation visit, Completes the mandatory 5 years review of the IB Middle Years Programme (MYP), Attends the MYP Next Chapter workshop in Malaysia to commence the transition of the programme, Secures accreditation by The College of Teachers (TCOT) as CPD Lead School to offer UK Certified Professional Development in Pakistan"
  },
  { 
    year: "2013-2014", 
    text: "PYP consultancy successfully completed, MYP e-Assessments successfully trialed, Expansion and refurbishment of the Primary Campus, Submission of application for PYP authorisation, Founded the Association of Middle East and South Asia IB World Schools in Pakistan (MESA), Introduction of Global Politics in the Diploma Programme, Successful trial of the PYP Exhibition, Redesign of the TIS uniform"
  },
  { 
    year: "2014-2015", 
    text: "Appointment of the first Principal, Authorisation of Primary Years Programme from IBO, Launch of co-branded Visa/UBL/TIS prepaid card, Renaming of MESA to IBPAK, Launch of International Days, Appointment of Heads of Departments"
  },
  { 
    year: "2015-2016", 
    text: "Moved Secondary Campus to F23 Block 5 Clifton, Successful IB MYP/DP 5-years Programme Evaluation Review, Ms Henna Ahmed takes charge as MYP Coordinator, TIS Graduates 13th batch of DP graduates, TIS successfully promotes 17th batch of MYP graduates"
  },
  { 
    year: "2016-2017", 
    text: "Ms Raheela Mukaddam joins TIS as PYP Coordinator, TIS Graduates 14th batch of DP graduates, TIS successfully promotes 18th batch of MYP graduates"
  },
  { 
    year: "2017-2018", 
    text: "Successful IB PYP 5 Years Programme Evaluation Review, TIS Graduates 15th batch of DP graduates, TIS successfully promotes 19th batch of MYP graduates"
  },
  { 
    year: "2019-2020", 
    text: "Ms. Samrah Afghan takes charge as PYP Coordinator, Mr. Tahir Manto Takes charge as MYP Coordinator, TIS goes online due to Covid-19, TIS Graduates 16th batch of DP graduates, TIS successfully promotes 20th batch of MYP graduates"
  },
  { 
    year: "2020-2021", 
    text: "Taymur Mirza takes on the role as Principal, Ms. Fehmeena Karim joins TIS as PYP Coordinator, Ms. Muzna Akbr Takes charge as MYP Coordinator, TIS Graduates 17th batch of DP graduates, TIS successfully promotes 21st batch of MYP graduates"
  },
  { 
    year: "2021-2022", 
    text: "Successful IB Multi-programme (PYP-MYP-DP) 5 Years Review, Ms Rumaisa Kidwai takes charge as PYP Coordinator, Face to Face teaching at TIS resumes, TIS Graduates 18th batch of DP graduates, TIS successfully promotes 22nd batch of MYP graduates"
  },
  { 
    year: "2022-2023", 
    text: "Ms. Saadia Zafar takes charge as MYP coordinator and IE Coordinator, TIS Graduates 19th batch of DP graduates, TIS successfully promotes 23rd batch of MYP graduates"
  },
  { 
    year: "2023-2024", 
    text: "Ms. Mahjabeen Rafay joins TIS as DP Coordinator and EE Coordinator, Ms. Aimen Mirza joins TIS as CAS Coordinator, TIS Graduates 20th batch of DP graduates, TIS successfully promotes 24th batch of MYP graduates"
  }
];




const Timeline = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  // Auto-scroll every second
  useEffect(() => {

    
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => {
        if (prevIndex + 1 < schoolTimeline.length) {
          return prevIndex + 1;
        }
        return 0;  // Reset to the start after the last item
      });
    }, 1000);  // Set interval to 1 second

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Check for mobile screen size
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check on component mount

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleScroll = (event) => {
    if (event.deltaY > 0) {
      // Scroll down, show next item
      if (currentIndex + 1 < schoolTimeline.length) {
        setCurrentIndex(currentIndex + 1);
      }
    } else {
      // Scroll up, show previous item
      if (currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
      }
    }
  };
  const itemsToShow = isMobile ? 2 : 3;
  return (
    <div className="timeline-container" onWheel={handleScroll}>
      <div className="timeline-line"></div>
      <ul className="timeline">
        {schoolTimeline.slice(currentIndex, currentIndex + itemsToShow).map((item, index) => (
          <li key={index}>
            {/* Add the big dot */}
            <span className="big-dot"></span>
            {/* Add the year on the left */}
            <span className="year">{item.year}</span>
            {/* Small dot at the connection */}
            <span className="dot"></span>
            {/* Add the year value on the right */}
            <div className="year-value">{item.text}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Timeline;
